module.exports = __webpack_public_path__ + "static/img/img-home-jzg-01.a811946.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-jzg-01.png
// module id = yKJl
// module chunks = 1